<template>
    <thank-you-stepper-base
        image-src="img/svg/thank-you.svg"
        image-container-class="image-container d-flex flex-column justify-content-center align-items-center mb-0 px-3"
        message-class="font-weight-bold text-center mt-1 mb-0"
        message="You have successfully Created your account"
        action-row-class="mt-2 justify-content-center"
        action-col-md="2"
        action-button-class="btn btn-block"
        button-text="Done"
        button-btn-color="primary"
        @done="$emit('done')"
    />
</template>
<script>
import ThankYouStepperBase from "@/components/Common/ThankYouStepperBase.vue";

export default {
    name: "ThankYou",
    components: {
        ThankYouStepperBase,
    },
};
</script>
<style scoped>
.image-container {
    width: 100%;
    box-sizing: border-box;
}

.image {
    display: block; /* prevents inline-image baseline gaps */
}

[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}
</style>
